module.exports = __webpack_public_path__ + "img/EnviromentalSustainability.44af0532.png";